import { SP } from "../../http/serviceportalApi";
import { useTranslations } from "../../hooks/useTranslations";
import Badge from "../ui/Badge";

interface Props {
  invite: SP.Invite;
}

const InviteStatus = ({ invite }: Props) => {
  const { i18n } = useTranslations();
  const now = new Date();
  return invite.declinedAt ? (
    <Badge color="red">{i18n.invites.status.declined}</Badge>
  ) : new Date(invite.expiresAt) > now ? (
    <Badge color="yellow">{i18n.invites.status.pending}</Badge>
  ) : (
    <Badge color="red">{i18n.invites.status.expired}</Badge>
  );
};

export default InviteStatus;
